<script lang="ts">
    let { class: className = "" }: { class?: string } = $props();
</script>

<div id="ad-top-banner" class="min-h-[120px] max-h-[120px] overflow-hidden {className}"></div>
